import React from "react";
import { UserTransactionList } from "components/user-transaction/UserTransactionList";
import { Provider } from "components/user-transaction/UserTransactionContext";

export const UserTransactions = () => {
    return (
        <Provider>
            <UserTransactionList />
        </Provider>
    );
};
